import { Box, Link } from '@chakra-ui/react'
import { Link as ReactRouterLink } from 'react-router-dom'

const EpidemiologyDashboardBanner = ({
  mb,
  href,
}: {
  mb?: string | number
  href: string
}) => {
  return (
    <Box
      p='12px'
      bg='gray.50'
      border='1px solid'
      borderColor='gray3'
      borderRadius='8px'
      fontSize='14px'
      gap='8px'
      mb={mb}
    >
      Explore our{' '}
      <Link as={ReactRouterLink} to={href} fontWeight={500}>
        interactive dashboard
      </Link>{' '}
      covering respiratory infectious diseases. Compare peak timing, test
      positivity, and hospitalisations to support combination vaccine
      development and strategies.
    </Box>
  )
}

export default EpidemiologyDashboardBanner
